import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import * as api from '../../api';
import { GetProjectThumbnails } from '../../api';
import { supabase } from '../../lib/supabaseClient';
import Spinner from '../Atoms/Spinner';

// ─── Constants ──────────────────────────────────────────────
const EVENT_ID_4TH = '67590da5499bcc995c210b40';

const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc', '67a0b8331b103d938bafa954', '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c', '67e6c18043d5609350e381a8', '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73', '67bf2330b1ba28c3144af8d2', '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63', '67c6b416db48cb16a13c73c7', '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c', '67d15108d95ccf24eaf191df', '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e', '662adc507159e5b1b1da7c75', '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2', '682b5c5f754f51df2ef93bbc', '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb', '67daebf343d5609350e27a9e', '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360', '67e1452a43d5609350e2b066', '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97', '67e3e1cb43d5609350e304e5', '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a', '67e42d7043d5609350e32539', '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0', '67e529f743d5609350e33a8c', '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f', '67e5764d43d5609350e34cb5', '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3', '67e58da443d5609350e3561d', '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905', '67e6828d43d5609350e36b6a', '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667', '67e6c0a843d5609350e380cf', '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900', '67e7003c43d5609350e38bfc', '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae', '67f90250a0262e085d37088f', '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e', '67ab6ade07736060460b3c16', '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d', '6800b8529167c049fff50e47', '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f', '6800fad59167c049fff52224', '680113739167c049fff52d73',
    '680106139167c049fff525af', '680125219167c049fff53405', '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e', '68020ef79167c049fff54015', '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7', '680249249167c049fff55a19', '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037', '680270379167c049fff566f5', '680274c09167c049fff567c8',
    '680275419167c049fff567de', '68027b389167c049fff56954', '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f', '6849787b17dde4ca4c4bf043', '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4', '6808c3f59167c049fff599c7', '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee', '6801e2f49167c049fff53ce1', '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49', '6810df4a264e7745556ad75d', '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977', '680fa9f09167c049fff5e027', '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62', '6818cac19e656d77bc6c72fa', '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0', '682d97b2754f51df2ef96070', '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a',
];

const EDITIONS = [
    { key: '1st', label_fr: '1re édition', label_en: '1st Edition', supabaseId: 'ec25d885-3dcf-455c-93b2-26041cb842e4' },
    { key: '2nd', label_fr: '2e édition', label_en: '2nd Edition', supabaseId: '417b2020-721a-4c55-bd9f-d86a913f26ad' },
    { key: '3rd', label_fr: '3e édition', label_en: '3rd Edition', supabaseId: 'a3b7c9d1-e5f6-4a2b-8c3d-1e5f6a2b8c3d' },
    { key: '4th', label_fr: '4e édition', label_en: '4th Edition', supabaseId: null },
];

// ─── Styled Components ──────────────────────────────────────
const PageWrapper = styled.div`
    background: #fafbfc;
    min-height: 100vh;
    overflow-x: hidden;
    box-sizing: border-box;
`;

const HeroSection = styled.div`
    background: white;
    color: #1a1a1a;
    padding: 32px 20px 24px;
    text-align: center;
    border-bottom: 1px solid #eee;

    @media (max-width: 768px) {
        padding: 24px 16px 20px;
    }
`;

const HeroLogo = styled.img`
    max-width: 280px;
    margin-bottom: 12px;

    @media (max-width: 768px) {
        max-width: 200px;
    }
`;

const HeroTitle = styled.h1`
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 8px 0;
    letter-spacing: 0.5px;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 22px;
    }
`;

const HeroSubtitle = styled.p`
    font-size: 14px;
    color: #777;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.5;

    @media (max-width: 768px) {
        font-size: 13px;
    }
`;

const EditionTabsSection = styled.div`
    background: white;
    border-bottom: 1px solid #e8e8e8;
    padding: 16px 0;
`;

const EditionTabsInner = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
`;

const EditionTab = styled.button`
    padding: 10px 24px;
    border-radius: 100px;
    border: 1.5px solid ${props => props.active ? '#1a1a1a' : '#ddd'};
    background: ${props => props.active ? '#1a1a1a' : 'white'};
    color: ${props => props.active ? 'white' : '#555'};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover {
        border-color: #1a1a1a;
        color: ${props => props.active ? 'white' : '#1a1a1a'};
    }
`;

const Container = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;
`;

const ToolbarSection = styled.div`
    position: sticky;
    top: 0;
    z-index: 100;
    background: white;
    border-bottom: 1px solid #e8e8e8;
    padding: 16px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
`;

const ToolbarInner = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

const FilterTabs = styled.div`
    display: flex;
    gap: 6px;
`;

const FilterTab = styled.button`
    padding: 8px 20px;
    border-radius: 100px;
    border: 1.5px solid ${props => props.active ? 'rgb(24, 51, 189)' : '#ddd'};
    background: ${props => props.active ? 'rgb(24, 51, 189)' : 'white'};
    color: ${props => props.active ? 'white' : '#555'};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover {
        border-color: rgb(24, 51, 189);
        color: ${props => props.active ? 'white' : 'rgb(24, 51, 189)'};
    }
`;

const SearchInput = styled.input`
    padding: 10px 16px;
    border: 1.5px solid #ddd;
    border-radius: 100px;
    font-size: 14px;
    outline: none;
    width: 260px;
    transition: border-color 0.2s;

    &:focus {
        border-color: rgb(24, 51, 189);
        box-shadow: 0 0 0 3px rgba(24, 51, 189, 0.08);
    }

    &::placeholder { color: #bbb; }

    @media (max-width: 600px) {
        width: 100%;
    }
`;

const CountLabel = styled.span`
    font-size: 13px;
    color: #999;
    white-space: nowrap;
`;

const GridSection = styled.div`
    padding: 32px 0 60px;
`;

const ProjectGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;

    @media (max-width: 1100px) {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
    }
    @media (max-width: 480px) {
        grid-template-columns: minmax(0, 1fr);
        max-width: 360px;
        margin: 0 auto;
    }
`;

const CardWrapper = styled.div`
    min-width: 0;
    overflow: hidden;
`;

const Card = styled.div`
    background: white;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    transition: all 0.25s ease;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
        border-color: #ccc;
    }
`;

const CardImageWrapper = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 75%;
    background-color: #f0f0f0;
    cursor: ${props => props.clickable ? 'pointer' : 'default'};
`;

const CardImage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-color: #f0f0f0;
    transition: transform 0.3s ease;

    ${Card}:hover & {
        transform: scale(1.03);
    }
`;

const TypeBadge = styled.span`
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    z-index: 2;
    background: ${props => props.type === 'objet'
        ? 'rgba(24, 51, 189, 0.9)'
        : 'rgba(0, 137, 123, 0.9)'};
    color: white;
`;

const CardBody = styled.div`
    padding: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const CardName = styled.h3`
    font-size: 15px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 4px 0;
    line-height: 1.3;
    height: 2.6em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-transform: uppercase;
`;

const CardDesigner = styled.p`
    font-size: 13px;
    color: #888;
    margin: 0 0 12px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
`;

const CardActions = styled.div`
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
`;

const CardButton = styled(Link)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s;
    flex: 1;
    text-align: center;
    white-space: nowrap;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
    }
`;

const ProjectButton = styled(CardButton)`
    background: rgb(24, 51, 189);
    color: white;

    &:visited {
        color: white;
    }

    &:hover {
        background: rgb(18, 38, 140);
        color: white;
    }
`;

const AgencyButton = styled(CardButton)`
    background: #f0f0f0;
    color: #333;
    border: 1px solid #ddd;

    &:visited {
        color: #333;
    }

    &:hover {
        background: #e5e5e5;
        color: #333;
    }
`;

const EmptyState = styled.div`
    text-align: center;
    padding: 60px 20px;
    color: #999;
    font-size: 16px;
`;

const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 20px;
`;

// ─── Admin Styled Components ────────────────────────────────
const EditPencilButton = styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 3;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: rgba(243, 156, 18, 0.95);
    color: white;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);

    &:hover {
        background: #e67e22;
        transform: scale(1.1);
    }
`;

const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

const ModalContent = styled.div`
    background: white;
    border-radius: 16px;
    padding: 24px;
    max-width: 680px;
    width: 90%;
    max-height: 85vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const ModalHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #eee;

    h3 {
        margin: 0;
        font-size: 18px;
        color: #333;
    }
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    padding: 0;
    line-height: 1;

    &:hover {
        color: #333;
    }
`;

const FormGroup = styled.div`
    margin-bottom: 16px;

    label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        margin-bottom: 6px;
    }

    input, textarea, select {
        width: 100%;
        padding: 10px 12px;
        border: 1px solid #ddd;
        border-radius: 8px;
        font-size: 14px;
        transition: border-color 0.2s;
        box-sizing: border-box;

        &:focus {
            outline: none;
            border-color: #f39c12;
        }
    }

    textarea {
        min-height: 80px;
        resize: vertical;
        font-family: inherit;
    }

    select {
        cursor: pointer;
        appearance: auto;
    }
`;

const FormRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;

    @media (max-width: 500px) {
        grid-template-columns: 1fr;
    }
`;

const MongoHint = styled.span`
    font-size: 11px;
    color: #28a745;
    font-weight: 400;
    margin-left: 8px;
`;

const SaveButton = styled.button`
    width: 100%;
    padding: 12px;
    background: linear-gradient(135deg, #f39c12, #e67e22);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-top: 16px;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(243, 156, 18, 0.4);
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }
`;

const ImageUploadArea = styled.div`
    border: 2px dashed ${props => props.dragOver ? '#f39c12' : '#ddd'};
    border-radius: 12px;
    padding: 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
    background: ${props => props.dragOver ? '#fff8e1' : '#fafafa'};

    &:hover {
        border-color: #f39c12;
        background: #fff8e1;
    }

    p {
        margin: 0;
        font-size: 14px;
        color: #888;
    }

    .formats {
        font-size: 12px;
        color: #bbb;
        margin-top: 4px;
    }
`;

const ImagePreviewGrid = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 12px;
`;

const ImagePreviewItem = styled.div`
    position: relative;
    width: 100px;
    height: 75px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #eee;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    button {
        position: absolute;
        top: 2px;
        right: 2px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: none;
        background: rgba(220, 53, 69, 0.9);
        color: white;
        font-size: 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;

        &:hover {
            background: #c82333;
        }
    }
`;

const AdminBanner = styled.div`
    background: linear-gradient(135deg, #f39c12, #e67e22);
    color: white;
    text-align: center;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
`;

// ─── Component ──────────────────────────────────────────────
const FD100Gallery = ({ fullUser }) => {
    const { i18n } = useTranslation('common');
    const isFr = i18n.language === 'fr';
    const navigate = useNavigate();
    const isAdmin = fullUser?.user?.role === 'admin';

    const [activeEdition, setActiveEdition] = useState('4th');
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('all');
    const [search, setSearch] = useState('');

    // 4th edition data
    const [definitiveNames, setDefinitiveNames] = useState({});
    const [projectsBasicData, setProjectsBasicData] = useState({});

    // Past editions data (keyed by edition key)
    const [pastWinners, setPastWinners] = useState({});
    const [pastThumbnails, setPastThumbnails] = useState({});
    const [pastCompleteness, setPastCompleteness] = useState({});

    // Admin gallery enrichments (keyed by winner_id)
    const [galleryProjects, setGalleryProjects] = useState({});

    // Admin edit modal
    const [editModal, setEditModal] = useState(null);
    const [saving, setSaving] = useState(false);
    const [pendingFiles, setPendingFiles] = useState([]);
    const [dragOver, setDragOver] = useState(false);
    const fileInputRef = useRef(null);

    // Track which editions have been loaded
    const [loadedEditions, setLoadedEditions] = useState(new Set());

    // Load 4th edition on mount
    useEffect(() => {
        load4thEdition();
    }, []);

    // Load past edition data when tab changes
    useEffect(() => {
        const edition = EDITIONS.find(e => e.key === activeEdition);
        if (edition && edition.supabaseId && !loadedEditions.has(edition.key)) {
            loadPastEdition(edition);
        }
    }, [activeEdition]);

    const load4thEdition = async () => {
        setLoading(true);
        try {
            const [namesRes, basicRes] = await Promise.all([
                supabase
                    .from('fd100_project_names')
                    .select('*')
                    .eq('event_id', EVENT_ID_4TH),
                api.getProjectsBasicData({ projectIds: WINNER_PROJECT_IDS }),
            ]);
            if (namesRes.data) {
                const map = {};
                namesRes.data.forEach(item => {
                    map[item.project_id] = {
                        name_fr: item.name_definitive_fr,
                        name_en: item.name_definitive_en,
                        designer: item.designer_definitive,
                    };
                });
                setDefinitiveNames(map);
            }
            if (basicRes.data) {
                setProjectsBasicData(basicRes.data);
            }
            setLoadedEditions(prev => new Set(prev).add('4th'));
        } catch (err) {
            console.error('Error loading 4th edition:', err);
        } finally {
            setLoading(false);
        }
    };

    const loadPastEdition = async (edition) => {
        setLoading(true);
        try {
            // Fetch winners + gallery enrichments in parallel
            const [winnersRes, galleryRes] = await Promise.all([
                supabase
                    .from('winners')
                    .select('*')
                    .eq('event_id', edition.supabaseId)
                    .order('company_name', { ascending: true }),
                supabase
                    .from('fd100_gallery_projects')
                    .select('*'),
            ]);

            if (winnersRes.error) {
                console.error('Error fetching winners:', winnersRes.error);
                setLoading(false);
                return;
            }

            const winnersData = winnersRes.data || [];
            setPastWinners(prev => ({ ...prev, [edition.key]: winnersData }));

            // Store gallery enrichments keyed by winner_id
            if (galleryRes.data) {
                const gpMap = { ...galleryProjects };
                galleryRes.data.forEach(gp => {
                    gpMap[gp.winner_id] = gp;
                });
                setGalleryProjects(gpMap);
            }

            // Fetch thumbnails + completeness for winners that have project_id + company_id
            const linkedItems = winnersData
                .filter(w => w.project_id && w.company_id)
                .map(w => ({ project_id: w.project_id, company_id: w.company_id }));

            if (linkedItems.length > 0) {
                try {
                    const thumbResponse = await GetProjectThumbnails(linkedItems);
                    const data = thumbResponse.data || {};
                    if (data.thumbnails) {
                        setPastThumbnails(prev => ({ ...prev, [edition.key]: data.thumbnails }));
                        setPastCompleteness(prev => ({ ...prev, [edition.key]: data.completeness || {} }));
                    } else {
                        setPastThumbnails(prev => ({ ...prev, [edition.key]: data }));
                    }
                } catch (thumbErr) {
                    console.error('Error fetching thumbnails:', thumbErr);
                }
            }

            setLoadedEditions(prev => new Set(prev).add(edition.key));
        } catch (err) {
            console.error('Error loading past edition:', err);
        } finally {
            setLoading(false);
        }
    };

    // Normalize projects from both data sources into a unified shape
    const normalizedProjects = useMemo(() => {
        if (activeEdition === '4th') {
            return WINNER_PROJECT_IDS.map(pid => {
                const def = definitiveNames[pid];
                const basic = projectsBasicData[pid];
                const imagePath = basic?.imagePath;
                return {
                    id: pid,
                    name: isFr
                        ? (def?.name_fr || def?.name_en || '')
                        : (def?.name_en || def?.name_fr || ''),
                    designer: def?.designer || '',
                    type: basic?.type || 'objet',
                    imageUrl: imagePath
                        ? process.env.REACT_APP_MEDIA_BASE_URL + 'userfiles/' + imagePath
                        : null,
                    projectLink: `/vote/fd100/${pid}`,
                    companyLink: basic?.companyId ? `/company?id=${basic.companyId}` : null,
                };
            });
        }

        // Past editions — merge: MongoDB > gallery enrichment > winners fallback
        const winners = pastWinners[activeEdition] || [];
        const thumbs = pastThumbnails[activeEdition] || {};
        const compl = pastCompleteness[activeEdition] || {};

        return winners.map(w => {
            const thumbPath = thumbs[w.project_id];
            const compData = compl[w.project_id]; // MongoDB completeness data
            const gp = galleryProjects[w.id];      // Admin Supabase enrichment

            // Image: MongoDB thumbnail > gallery image > none
            const mongoImageUrl = thumbPath
                ? process.env.REACT_APP_MEDIA_BASE_URL + thumbPath
                : null;
            const galleryImageUrl = gp?.image_urls?.length > 0 ? gp.image_urls[0] : null;
            const imageUrl = mongoImageUrl || galleryImageUrl || null;

            // Type: MongoDB > gallery > null
            const type = compData?.type || gp?.type || null;

            // Name: MongoDB > gallery > winners fallback
            let name = w.project_name || '';
            if (compData) {
                const enrichedName = isFr
                    ? (compData.name || compData.nameEn)
                    : (compData.nameEn || compData.name);
                if (enrichedName) name = enrichedName;
            } else if (gp) {
                const galleryName = isFr
                    ? (gp.name_fr || gp.name_en)
                    : (gp.name_en || gp.name_fr);
                if (galleryName) name = galleryName;
            }

            // Designer: gallery > winners fallback (MongoDB doesn't have designer in completeness)
            const designer = gp?.designer || w.company_name || `${w.first_name || ''} ${w.last_name || ''}`.trim();

            const projectLink = (w.project_id && w.company_id)
                ? `/project?pid=${w.project_id}&cid=${w.company_id}`
                : null;
            const companyLink = w.company_id
                ? `/company?id=${w.company_id}`
                : null;

            return {
                id: w.id,
                winnerId: w.id,
                name,
                designer,
                type,
                imageUrl,
                projectLink,
                companyLink,
                // Admin-only fields for edit modal
                _mongoData: compData || null,
                _galleryProject: gp || null,
                _winner: w,
            };
        });
    }, [activeEdition, definitiveNames, projectsBasicData, pastWinners, pastThumbnails, pastCompleteness, galleryProjects, isFr]);

    // Filter and search
    const filteredProjects = useMemo(() => {
        let result = [...normalizedProjects];
        if (filter === 'objet') {
            result = result.filter(p => p.type === 'objet');
        } else if (filter === 'espace') {
            result = result.filter(p => p.type === 'espace');
        }
        if (search.trim()) {
            const q = search.trim().toLowerCase();
            result = result.filter(p =>
                p.name.toLowerCase().includes(q) ||
                p.designer.toLowerCase().includes(q)
            );
        }
        return result.sort((a, b) => a.name.localeCompare(b.name));
    }, [normalizedProjects, filter, search]);

    const handleEditionChange = (key) => {
        setActiveEdition(key);
        setFilter('all');
        setSearch('');
    };

    const handleImageClick = (project) => {
        if (project.projectLink) {
            navigate(project.projectLink);
        }
    };

    // ─── Admin Edit Handlers ────────────────────────────────
    const openEditModal = (project) => {
        const gp = project._galleryProject;
        const mongo = project._mongoData;
        const w = project._winner;

        setEditModal({
            winnerId: project.winnerId,
            name_fr: gp?.name_fr || '',
            name_en: gp?.name_en || '',
            designer: gp?.designer || '',
            type: gp?.type || '',
            description_fr: gp?.description_fr || '',
            description_en: gp?.description_en || '',
            year: gp?.year || '',
            image_urls: gp?.image_urls || [],
            // Context for display
            _mongoData: mongo,
            _winnerName: w?.project_name || '',
            _winnerCompany: w?.company_name || '',
        });
        setPendingFiles([]);
    };

    const closeEditModal = () => {
        setEditModal(null);
        setPendingFiles([]);
        setDragOver(false);
    };

    const handleEditChange = (field, value) => {
        setEditModal(prev => ({ ...prev, [field]: value }));
    };

    const handleFileSelect = (files) => {
        const validFiles = Array.from(files).filter(f =>
            ['image/jpeg', 'image/png', 'image/webp'].includes(f.type) && f.size <= 20 * 1024 * 1024
        );
        setPendingFiles(prev => [...prev, ...validFiles]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        if (e.dataTransfer.files) {
            handleFileSelect(e.dataTransfer.files);
        }
    };

    const removePendingFile = (index) => {
        setPendingFiles(prev => prev.filter((_, i) => i !== index));
    };

    const removeExistingImage = (url) => {
        setEditModal(prev => ({
            ...prev,
            image_urls: prev.image_urls.filter(u => u !== url),
        }));
    };

    const uploadImageToStorage = async (file) => {
        const ext = file.name.split('.').pop().toLowerCase();
        const fileName = `${activeEdition}/${Date.now()}_${Math.random().toString(36).slice(2, 8)}.${ext}`;
        const { error } = await supabase.storage
            .from('fd100-gallery-media')
            .upload(fileName, file);
        if (error) throw error;
        const { data: { publicUrl } } = supabase.storage
            .from('fd100-gallery-media')
            .getPublicUrl(fileName);
        return publicUrl;
    };

    const handleSaveEdit = async () => {
        if (!editModal) return;
        setSaving(true);
        try {
            // Upload pending files
            const uploadedUrls = [];
            for (const file of pendingFiles) {
                const url = await uploadImageToStorage(file);
                uploadedUrls.push(url);
            }

            const allImageUrls = [...editModal.image_urls, ...uploadedUrls];

            const payload = {
                winner_id: editModal.winnerId,
                name_fr: editModal.name_fr || null,
                name_en: editModal.name_en || null,
                designer: editModal.designer || null,
                type: editModal.type || null,
                description_fr: editModal.description_fr || null,
                description_en: editModal.description_en || null,
                year: editModal.year || null,
                image_urls: allImageUrls,
            };

            const { error } = await supabase
                .from('fd100_gallery_projects')
                .upsert(payload, { onConflict: 'winner_id' });

            if (error) {
                console.error('Error saving gallery project:', error);
                return;
            }

            // Update local state
            setGalleryProjects(prev => ({
                ...prev,
                [editModal.winnerId]: { ...prev[editModal.winnerId], ...payload },
            }));

            closeEditModal();
        } catch (err) {
            console.error('Error saving:', err);
        } finally {
            setSaving(false);
        }
    };

    const isCurrentEditionLoaded = loadedEditions.has(activeEdition);
    const isPastEdition = activeEdition !== '4th';

    return (
        <PageWrapper>
            {isAdmin && <AdminBanner>Mode admin — vous pouvez modifier les projets des editions passees</AdminBanner>}

            <HeroSection>
                <HeroLogo src="/assets/fd100-kit/logos/SD25-FD100-Logo-Story.png" alt="Le FD100" />
                <HeroTitle>Le French Design 100</HeroTitle>
                <HeroSubtitle>
                    {isFr
                        ? 'Les 100 projets lauréats de chaque édition, choisis par un jury international.'
                        : 'The 100 winning projects of each edition, chosen by an international jury.'}
                </HeroSubtitle>
            </HeroSection>

            <EditionTabsSection>
                <EditionTabsInner>
                    {EDITIONS.map(ed => (
                        <EditionTab
                            key={ed.key}
                            active={activeEdition === ed.key}
                            onClick={() => handleEditionChange(ed.key)}
                        >
                            {isFr ? ed.label_fr : ed.label_en}
                        </EditionTab>
                    ))}
                </EditionTabsInner>
            </EditionTabsSection>

            <ToolbarSection>
                <ToolbarInner>
                    <FilterTabs>
                        <FilterTab active={filter === 'all'} onClick={() => setFilter('all')}>
                            {isFr ? 'Tous' : 'All'}
                        </FilterTab>
                        <FilterTab active={filter === 'objet'} onClick={() => setFilter('objet')}>
                            {isFr ? 'Objets' : 'Objects'}
                        </FilterTab>
                        <FilterTab active={filter === 'espace'} onClick={() => setFilter('espace')}>
                            {isFr ? 'Espaces' : 'Spaces'}
                        </FilterTab>
                    </FilterTabs>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <SearchInput
                            placeholder={isFr ? 'Rechercher un projet ou designer...' : 'Search project or designer...'}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                        <CountLabel>
                            {filteredProjects.length} {isFr ? 'projets' : 'projects'}
                        </CountLabel>
                    </div>
                </ToolbarInner>
            </ToolbarSection>

            <GridSection>
                <Container>
                    {loading && !isCurrentEditionLoaded ? (
                        <LoadingWrapper><Spinner /></LoadingWrapper>
                    ) : filteredProjects.length === 0 ? (
                        <EmptyState>
                            {isFr ? 'Aucun projet trouvé.' : 'No projects found.'}
                        </EmptyState>
                    ) : (
                        <ProjectGrid>
                            {filteredProjects.map(project => (
                                <CardWrapper key={project.id}>
                                    <Card>
                                        <CardImageWrapper
                                            clickable={!!project.projectLink}
                                            onClick={() => handleImageClick(project)}
                                        >
                                            <CardImage style={{
                                                backgroundImage: project.imageUrl ? `url(${project.imageUrl})` : 'none'
                                            }} />
                                            {project.type && (
                                                <TypeBadge type={project.type}>
                                                    {project.type === 'objet'
                                                        ? (isFr ? 'Objet' : 'Object')
                                                        : (isFr ? 'Espace' : 'Space')}
                                                </TypeBadge>
                                            )}
                                            {isAdmin && isPastEdition && (
                                                <EditPencilButton
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        openEditModal(project);
                                                    }}
                                                    title="Modifier ce projet"
                                                >
                                                    &#9998;
                                                </EditPencilButton>
                                            )}
                                        </CardImageWrapper>
                                        <CardBody>
                                            <CardName>{project.name || (isFr ? 'Sans nom' : 'Untitled')}</CardName>
                                            <CardDesigner>{project.designer}</CardDesigner>
                                            {(project.projectLink || project.companyLink) && (
                                                <CardActions>
                                                    {project.projectLink && (
                                                        <ProjectButton
                                                            to={project.projectLink}
                                                            onClick={e => e.stopPropagation()}
                                                        >
                                                            {isFr ? 'Voir le projet' : 'View project'}
                                                        </ProjectButton>
                                                    )}
                                                    {project.companyLink && (
                                                        <AgencyButton
                                                            to={project.companyLink}
                                                            onClick={e => e.stopPropagation()}
                                                        >
                                                            {isFr ? 'Voir l\'agence' : 'View agency'}
                                                        </AgencyButton>
                                                    )}
                                                </CardActions>
                                            )}
                                        </CardBody>
                                    </Card>
                                </CardWrapper>
                            ))}
                        </ProjectGrid>
                    )}
                </Container>
            </GridSection>

            {/* Admin Edit Modal */}
            {editModal && (
                <ModalOverlay onClick={closeEditModal}>
                    <ModalContent onClick={e => e.stopPropagation()}>
                        <ModalHeader>
                            <h3>Modifier le projet</h3>
                            <CloseButton onClick={closeEditModal}>&times;</CloseButton>
                        </ModalHeader>

                        {/* Context info */}
                        <div style={{ background: '#f8f9fa', padding: '12px 16px', borderRadius: 8, marginBottom: 20, fontSize: 13 }}>
                            <strong>Laureat :</strong> {editModal._winnerCompany || '-'} — {editModal._winnerName || '-'}
                            {editModal._mongoData && (
                                <div style={{ marginTop: 4, color: '#28a745', fontSize: 12 }}>
                                    Ce laureat a un projet lie sur la plateforme (les donnees utilisateur sont prioritaires a l'affichage)
                                </div>
                            )}
                        </div>

                        <FormRow>
                            <FormGroup>
                                <label>
                                    Nom du projet (FR)
                                    {editModal._mongoData?.name && <MongoHint>(utilisateur: {editModal._mongoData.name})</MongoHint>}
                                </label>
                                <input
                                    type="text"
                                    value={editModal.name_fr}
                                    onChange={e => handleEditChange('name_fr', e.target.value)}
                                    placeholder={editModal._mongoData?.name || editModal._winnerName || ''}
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>
                                    Nom du projet (EN)
                                    {editModal._mongoData?.nameEn && <MongoHint>(utilisateur: {editModal._mongoData.nameEn})</MongoHint>}
                                </label>
                                <input
                                    type="text"
                                    value={editModal.name_en}
                                    onChange={e => handleEditChange('name_en', e.target.value)}
                                    placeholder={editModal._mongoData?.nameEn || ''}
                                />
                            </FormGroup>
                        </FormRow>

                        <FormRow>
                            <FormGroup>
                                <label>Designer / Entreprise</label>
                                <input
                                    type="text"
                                    value={editModal.designer}
                                    onChange={e => handleEditChange('designer', e.target.value)}
                                    placeholder={editModal._winnerCompany || ''}
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>
                                    Type
                                    {editModal._mongoData?.type && <MongoHint>(utilisateur: {editModal._mongoData.type})</MongoHint>}
                                </label>
                                <select
                                    value={editModal.type}
                                    onChange={e => handleEditChange('type', e.target.value)}
                                >
                                    <option value="">— Choisir —</option>
                                    <option value="objet">Objet</option>
                                    <option value="espace">Espace</option>
                                </select>
                            </FormGroup>
                        </FormRow>

                        <FormGroup>
                            <label>Annee</label>
                            <input
                                type="text"
                                value={editModal.year}
                                onChange={e => handleEditChange('year', e.target.value)}
                                placeholder={editModal._mongoData?.year || ''}
                                style={{ maxWidth: 200 }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <label>
                                Description (FR)
                                {editModal._mongoData?.aboutfr && <MongoHint>(rempli par l'utilisateur)</MongoHint>}
                            </label>
                            <textarea
                                value={editModal.description_fr}
                                onChange={e => handleEditChange('description_fr', e.target.value)}
                                placeholder={editModal._mongoData?.aboutfr ? 'L\'utilisateur a deja renseigne une description...' : ''}
                            />
                        </FormGroup>

                        <FormGroup>
                            <label>
                                Description (EN)
                                {editModal._mongoData?.abouten && <MongoHint>(rempli par l'utilisateur)</MongoHint>}
                            </label>
                            <textarea
                                value={editModal.description_en}
                                onChange={e => handleEditChange('description_en', e.target.value)}
                                placeholder={editModal._mongoData?.abouten ? 'User already provided a description...' : ''}
                            />
                        </FormGroup>

                        {/* Image upload */}
                        <FormGroup>
                            <label>Images</label>
                            <ImageUploadArea
                                dragOver={dragOver}
                                onClick={() => fileInputRef.current?.click()}
                                onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                                onDragLeave={() => setDragOver(false)}
                                onDrop={handleDrop}
                            >
                                <p>Cliquer ou glisser des images ici</p>
                                <p className="formats">JPG, PNG, WebP — 20 Mo max</p>
                            </ImageUploadArea>
                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/jpeg,image/png,image/webp"
                                multiple
                                style={{ display: 'none' }}
                                onChange={e => { handleFileSelect(e.target.files); e.target.value = ''; }}
                            />

                            {/* Existing images from Supabase */}
                            {editModal.image_urls.length > 0 && (
                                <ImagePreviewGrid>
                                    {editModal.image_urls.map((url, i) => (
                                        <ImagePreviewItem key={i}>
                                            <img src={url} alt={`Image ${i + 1}`} />
                                            <button onClick={() => removeExistingImage(url)} title="Supprimer">&times;</button>
                                        </ImagePreviewItem>
                                    ))}
                                </ImagePreviewGrid>
                            )}

                            {/* Pending files to upload */}
                            {pendingFiles.length > 0 && (
                                <ImagePreviewGrid>
                                    {pendingFiles.map((file, i) => (
                                        <ImagePreviewItem key={`new-${i}`}>
                                            <img src={URL.createObjectURL(file)} alt={file.name} />
                                            <button onClick={() => removePendingFile(i)} title="Retirer">&times;</button>
                                        </ImagePreviewItem>
                                    ))}
                                </ImagePreviewGrid>
                            )}

                            {/* MongoDB images hint */}
                            {editModal._mongoData?.medias?.filter(m => m.type?.includes('image')).length > 0 && (
                                <div style={{ fontSize: 12, color: '#28a745', marginTop: 8 }}>
                                    L'utilisateur a deja uploade {editModal._mongoData.medias.filter(m => m.type?.includes('image')).length} image(s) sur la plateforme (affichees en priorite)
                                </div>
                            )}
                        </FormGroup>

                        <SaveButton onClick={handleSaveEdit} disabled={saving}>
                            {saving ? 'Enregistrement...' : 'Enregistrer les modifications'}
                        </SaveButton>
                    </ModalContent>
                </ModalOverlay>
            )}
        </PageWrapper>
    );
};

export default FD100Gallery;
